
export default
    name: 'Rotator'
    data: ->
        src:  general.first_url
        urls: general.urls
        refresh_at: general.refresh_interval
        index: 0
    methods:
        rotate: ->
            if @index == @urls.length
                @index = 0
            @src = @urls[@index]
            @index++
            setTimeout (=> @rotate()), @refresh_at * 1000

    mounted: ->
        @rotate()
        @$root.$cable.subscribe({ channel: 'RotatorChannel', slug: @$root.slug })

    channels:
        RotatorChannel:
            received: (data) ->
                @urls = data.urls
                @refresh_at = data.refresh_at
                @src = @urls[0]

